<template>
  <div class="schlafworkshop">
    <div class="next-event-bubble-wrap-zone">
      <h1>Praxisnaher Onlineworkshop zu Baby- & Kleinkindschlaf</h1>
      <p>Du bist müde, dein Baby schläft unruhig - und gut gemeinte Ratschläge verunsichern dich nur noch mehr? Du willst verstehen, wie Kinder schlafen - und wie du sie liebevoll dabei begleiten kannst? Oder bist noch schwanger und möchtest mit Selbstbewusstsein in den neuen Abschnitt starten? Du hast gehört, dass Babys auch mal Schreien gelassen werden sollten, aber in dir sträubt es sich dagegen?</p>
      <p>Dann bist du genau richtig in meinem Kurs:</p>
    </div>
    <h2>Baby- und Kleinkindschlaf verstehen & unterstützen</h2>
    <p>Ich erkläre euch die Hintergründe zum Thema Schlaf und worauf es bei unseren Kleinsten wirklich ankommt:</p>
    <ul>
      <li>Basics: Schlafverhalten & Schlafentwicklung</li>
      <li>Was ist wichtig für erholsamen Schlaf?</li>
      <li>Schreien lassen? Nachteile von Schlaftrainings</li>
      <li>Einschlafbegleitung</li>
      <li>(Ein-)Schlafgewohnheiten</li>
      <li>Warum wachen Kinder nachts auf?</li>
      <li>Schlafumgebung & Sicherheit</li>
      <li>Die häufigsten Schlafstörungen</li>
      <li>Impulse für Veränderungen</li>
    </ul>
    <p>Kein Kind muss schlafen lernen, indem es schreiend allein gelassen wird. Denn jedes Kind kann schon schlafen.</p>
    <p>Am Ende bleibt selbstverständlich noch Zeit für eure Fragen. Der Schlaf unserer Kinder ist jedoch so individuell wie sie selbst. Bitte habt deshalb Verständnis, dass eine individuelle <router-link to="/schlafberatung/">Schlafberatung</router-link> aufgrund der begrenzten Zeit nicht möglich ist.</p>
    <NextEventBubble />
    <p>
      Ihr seid mindestens zu viert und möchtet einen <strong>privaten Kurs für eure Gruppe</strong>? Online oder vielleicht sogar ganz bequem bei euch zu Hause? Kein Problem – wir finden einen Termin und ich komme gerne vorbei!
    </p>
  </div>
</template>

<script>
import NextEventBubble from "@/components/NextEventBubble.vue";

export default {
  name: 'Schlafworkshop',
  components: {
    NextEventBubble
  }
}
</script>

<style scoped>
.schlafworkshop {
}
@media (min-width: 70rem) {
  .next-event-bubble-wrap-zone {
    padding-right: clamp(0rem, 50rem + -50vw, 15rem);
  }
}
</style>